import { X } from 'lucide-react'
import { AnimatePresence, motion } from 'framer-motion'

export default function ConfirmModal({
  type,
  title,
  message,
  onConfirm,
  onCancel,
  onClose,
}) {
  const renderMsg = () =>
    typeof message === 'string' ? (
      <p className="whitespace-pre-line">{message}</p>
    ) : (
      message
    )

  return (
    <AnimatePresence>
      <motion.div
        key="cmBack"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[1300] flex items-center justify-center p-4"
      >
        <motion.div
          key="cmCard"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.18 }}
          className="w-full max-w-md bg-white rounded-lg shadow-xl p-6 space-y-4"
        >
          <div className="flex items-start justify-between">
            {title && <h4 className="text-lg font-semibold">{title}</h4>}
            <button onClick={onClose ?? onCancel} className="text-gray-500 hover:text-primary">
              <X size={18} />
            </button>
          </div>

          <div className="text-sm text-gray-700">{renderMsg()}</div>

          {type === 'confirm' ? (
            <div className="flex justify-end gap-3 pt-2">
              <button
                onClick={onCancel}
                className="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-sm"
              >
                ยกเลิก
              </button>
              <button
                onClick={onConfirm}
                className="px-4 py-2 rounded-lg bg-danger hover:bg-danger/80 text-white text-sm"
              >
                ตกลง
              </button>
            </div>
          ) : (
            <div className="flex justify-end pt-2">
              <button
                onClick={onClose}
                className="px-4 py-2 rounded-lg bg-primary hover:bg-secondary text-white text-sm"
              >
                ปิด
              </button>
            </div>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  )
}
